<div style="padding: 16px">
  <app-tabla
    [datos]="recorridos"
    [columnas]="columnas"
    [paginatorArriba]="false"
    [totalCount]="recorridos?.length || 0"
    [emptyState]="{
      title: 'Este vehículo no tiene recorridos dinámicos',
      subtitle:
        'Acá vas a ver el historial de recorridos por puntos que se le asignaron, vigentes o finalizados.',
    }"
  ></app-tabla>
</div>
